angular.module('gantt.sortable.templates', []).run(['$templateCache', function ($templateCache) {

}]);
